import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { FileGridComponent } from './Modules/file-grid/file-grid.component';
import { UploadmodalComponent } from './uploadmodal/uploadmodal.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { FormsModule } from '@angular/forms';
import { OktaAuthModule, OKTA_CONFIG } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from 'src/environments/environment';
import { HomeComponent } from './Modules/home/home.component';
import { CBEMComponent } from './Modules/CBEM/cbem.component';
import { vTable }  from '../../components/veriskComponents/tables/veriskTable.component';
import { ChevronDown, ChevronRight, LucideAngularModule, ListFilter,Download } from 'lucide-angular';
import { BreadcrumbModule } from './StyleModules/oriModule';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CUSTOM_ELEMENTS_SCHEMA
 } from '@angular/core';
import { NgxSpinnerModule } from "ngx-spinner";
import { ClientTrackerComponent } from './Modules/client-navigator/client-navigator.component';
import { KENDO_LAYOUT } from '@progress/kendo-angular-layout';
import { ClientDashboardComponent } from './Modules/client-dashboard/client-dashboard.component';
import { EditColumnComponent } from '../../components/veriskComponents/reusable_ui/column_customize';
import { NotificationComponent } from './components/notification/notification.component';
import { OriPagination, OriPaginationContent, OriPaginationNext, OriPaginationPrevious } from '~/components/ui/pagination';
import { ReferralComponent } from './Modules/referral/referral.component';
import { ReferralDetailComponent } from './Modules/referral-detail/referral-detail.component';
import { ReferralReportsDialogComponent } from './Modules/referral-reports/referral-reports-dialog.component';
import { DynamoUtilityComponent } from './Modules/dynamo-utility/dynamo-utility.component';


const impCallback = 'login/callback';
let okta_redirectUri = `${location.origin}/${impCallback}`;

const oktaAuth = new OktaAuth({
  issuer: environment.okta_issuer,
  clientId: environment.okta_client_id,
  // redirectUri: environment.okta_redirect_uri
  redirectUri: okta_redirectUri,
  pkce: true
});

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FileGridComponent,
    UploadmodalComponent,
    CBEMComponent,
    ClientTrackerComponent,
    ClientDashboardComponent,
    NotificationComponent,
    ReferralComponent,
    ReferralDetailComponent,
    ReferralReportsDialogComponent,
    DynamoUtilityComponent,
  ],
  imports: [
    BrowserModule,
    NgbModule,
    AppRoutingModule,
    GridModule,
    DateInputsModule,
    DropDownsModule,
    DialogModule,
    FormsModule,
    HttpClientModule ,
    OktaAuthModule,
    // FileGridComponent,
    BrowserAnimationsModule,
    vTable,
    EditColumnComponent,
    LucideAngularModule,
    BreadcrumbModule,
    OriPagination,
    OriPaginationContent,
    OriPaginationPrevious,
    OriPaginationNext,
    OverlayModule,
    PortalModule,
    NgxSpinnerModule,
    LucideAngularModule.pick({ ChevronRight, ChevronDown, ListFilter,Download }),
    ...KENDO_LAYOUT,
  ],
  providers: [
    {
      provide: OKTA_CONFIG,
      useValue: { oktaAuth }
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
